import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LocationSearchInputBlock from './LocationSearchInputBlock';
import GeolocationButton from './presentionalComponents/GeolocationButton';

import { setLocationViaGeolocation } from '../../locationSearchHelpers';
import translations from '../../translations';


const PAGE_INFO_FOR_ANALYTICS = 'Listing page';

class LocationSearchBlock extends PureComponent {

  render() {
    const {
      geolocationEnabled,
      searchingGeolocation,
      name,
      pending
    } = this.props;

    const componentClasses = ['dc-location-search-block'];

    componentClasses.push(
      name === 'above product listing'
        ? 'dc-location-search-block-above-product-listing'
        : 'dc-location-search-block-filter-block'
    );

    return (
      <div className={componentClasses.join(' ')}>
        <div className="dc-location-search-block__label">
          {translations.postcodeCheckerLabel}
        </div>
        <LocationSearchInputBlock
          disabled={pending || searchingGeolocation}
          name={name}
        />
        {geolocationEnabled &&
          <Fragment>
            <div className="dc-location-search-block__or-label">
              {translations.geolocationOrLabel}
            </div>
            <div className="dc-location-search-block__geolocation-button">
              <GeolocationButton
                label={translations.geolocationButtonLabel}
                disabled={pending || searchingGeolocation}
                onClick={() => {
                  setLocationViaGeolocation(PAGE_INFO_FOR_ANALYTICS, name);
                }}
              />
            </div>
          </Fragment>
        }
      </div>
    );
  }
}


LocationSearchBlock.propTypes = {
  // DON'T CHANGE THE VALUES of the following prop, the format is due to analytics
  name: PropTypes.oneOf([
    'above product listing',
    'filter block'
  ]).isRequired,
  geolocationEnabled: PropTypes.bool.isRequired,
  searchingGeolocation: PropTypes.bool.isRequired,
  pending: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    geolocationEnabled: state.listingPage.locationSearch.geolocationEnabled,
    searchingGeolocation: state.listingPage.locationSearch.searchingGeolocation,
    pending: state.listingPage.locationSearch.pending
  };
}

export default connect(mapStateToProps)(LocationSearchBlock);
